export enum CUSTOM_FIELD_CATEGORIES {
  CASE = "case",
  EVIDENCE = "evidence",
  ACQUISITION = "acquisition",
  INQUIRY = "inquiry",
  STORAGE = "storage",
  PEOPLE = "people",
}

export type CustomField = {
  category: CUSTOM_FIELD_CATEGORIES;
  description: string;
  editor_type: "textBox" | "dropDown" | "dateBox" | "tagBox";
  enabled: 0 | 1;
  external_enabled: 0 | 1;
  field_id: number;
  field_name: string;
  is_common: 0 | 1;
  is_required: 0 | 1;
  options: string[] | null;
  sort_value: number;
  type_id: number;
  type_ids: number[] | null;
  linked_id?: number;
};
